/** Longest range the acquisition API accepts (ReportingCalendar.MaxRangeDays). */
export const ACQUISITION_MAX_RANGE_DAYS = 400;

/** Validation message for a yyyy-MM-dd range, or '' when it's valid. */
export function validateAcquisitionRange(from: string, to: string): string {
  if (!from || !to) {
    return 'Choose both a From and a To date.';
  }
  if (to < from) {
    return 'The To date must be on or after the From date.';
  }
  const days = (Date.parse(to) - Date.parse(from)) / 86_400_000 + 1;
  return days > ACQUISITION_MAX_RANGE_DAYS ? `Choose a range of ${ACQUISITION_MAX_RANGE_DAYS} days or less.` : '';
}

/** yyyy-MM-dd in the browser's local time zone (IST for the team), not UTC. */
export function formatLocalDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}
